import { render, staticRenderFns } from "./TradingList.vue?vue&type=template&id=05110a9a&scoped=true"
import script from "./TradingList.vue?vue&type=script&lang=ts"
export * from "./TradingList.vue?vue&type=script&lang=ts"
import style0 from "./TradingList.vue?vue&type=style&index=0&id=05110a9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05110a9a",
  null
  
)

export default component.exports